"use client";

import { useAnalytics } from "@/components/analytics/use-analytics";
import { Link } from "@/i18n/navigation";
import type { ReactNode } from "react";

type BlogPostLinkProps = {
  href: string;
  slug: string;
  title: string;
  className?: string;
  children: ReactNode;
};

export function BlogPostLink({
  href,
  slug,
  title,
  className,
  children,
}: BlogPostLinkProps) {
  const { trackEvent } = useAnalytics();

  const handleClick = () => {
    trackEvent("blog_post_clicked", { slug, title });
  };

  return (
    <Link href={href} className={className} onClick={handleClick}>
      {children}
    </Link>
  );
}
